<h2 mat-dialog-title>{{ "survey.external.exit-dialog.title" | translate }}</h2>

<mat-dialog-content class="mat-typography">
    <p>{{ "survey.external.exit-dialog.body" | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions class="d-block text-end">
    <a class="btn btn-secondary me-1" mat-dialog-close>
        {{ "survey.external.exit-dialog.undo" | translate }}
    </a>
    <a class="btn btn-primary" (click)="doConfirm()">
        {{ "survey.external.exit-dialog.confirm" | translate }}
    </a>
</mat-dialog-actions>